import React, { memo } from 'react'
import classNames from 'classnames'
import { SvgIconProps } from 'transfix-ui/core'
import { IStop } from 'types'
import { LightningFilledIcon } from 'transfix-icons'
import { Tooltip } from 'transfix-ui'
import { apptClass } from 'utils/appointmentHelpers'
import { STOP_STATUS } from 'constants/stops'
import { Bullet } from '../atoms'

interface IStopSummaryProps {
  stop: IStop
  variation: string
  totalNumStops?: number
  icons?: SvgIconProps[]
}

export const StopSummary = memo<IStopSummaryProps>(
  ({ stop, variation, totalNumStops, icons = [] }) => {
    const isBold = classNames({ b: variation === 'fullWidth' })
    const apptStatusClass = stop?.time ? apptClass(stop.status) : ''
    const isPredictedAppt = stop.status === STOP_STATUS.PREDICTED
    if (variation === 'large') {
      return (
        <div className='dib'>
          <h3 className='mb0'>
            {stop.city}, {stop.state || stop.stateCode}{' '}
            <small className='text-secondary'>{stop.zip}</small>
          </h3>
          <p className='pt0'>
            {isPredictedAppt ? (
              <Tooltip
                position='bottom'
                id='predicted'
                trigger={
                  <span className='flex items-center'>
                    <span>{stop.date && `${stop.date} `}</span>
                    <LightningFilledIcon className='ml1' color='warning' />
                    <span className={apptStatusClass}>
                      {stop?.time ? ` ${stop?.time} ${stop.timezone}` : 'TBD'}
                    </span>
                  </span>
                }>
                This prediction is based on historical data.
              </Tooltip>
            ) : (
              <>
                <span>{stop.date && `${stop.date} `}</span>
                <span className={apptStatusClass}>
                  {stop?.time ? ` ${stop?.time} ${stop.timezone}` : 'TBD'}
                </span>
              </>
            )}
          </p>
        </div>
      )
    }
    if (variation === 'inline') {
      return (
        <div className='flex items-center w-100'>
          <div className='mr2'>
            <strong>
              {stop.city}, {stop.state || stop.stateCode}&nbsp;&nbsp;
            </strong>
            {isPredictedAppt ? (
              <Tooltip
                position='bottom'
                id='predicted'
                trigger={
                  <span className='mr2'>
                    <span>{stop.date && `${stop.date} `}</span>
                    <LightningFilledIcon className='ml1' color='warning' />
                    <span className={apptStatusClass}>
                      {stop.time ? `${stop.time} ${stop.timezone}` : 'TBD'}
                    </span>
                  </span>
                }>
                This prediction is based on historical data.
              </Tooltip>
            ) : (
              <>
                <span>{stop.date && `${stop.date} `}</span>
                <span className={apptStatusClass}>
                  {stop.time ? `${stop.time} ${stop.timezone}` : 'TBD'}
                </span>
                {totalNumStops && totalNumStops > 1 && <strong>&nbsp;+{totalNumStops - 1}</strong>}
              </>
            )}
          </div>
          {icons &&
            icons.map(icon => (
              <span className='mr1 no-shrink' key={icon.id}>
                {icon}
              </span>
            ))}
        </div>
      )
    }
    if (variation === 'inline-primary') {
      return (
        <span>
          {stop.city}, {stop.state || stop.stateCode}{' '}
        </span>
      )
    }
    if (variation === 'inline-secondary') {
      return (
        <span className='text-secondary'>
          {stop.city}, {stop.state || stop.stateCode}{' '}
        </span>
      )
    }
    return (
      <>
        <p className={isBold}>
          {stop.city}, {stop.state}
          <Bullet />
          {stop.zip}
        </p>
        {stop.date && <small>{stop.date}</small>}
      </>
    )
  }
)

export default StopSummary
